import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

/*********************************************Remote Price Customer Group Section*********************************************************** */
/**
 * 
 * @param salesOrg 
 * @returns 
 */
export async function getCustomerGroups(salesOrg: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
    },
    url: `${BASE_URL}/api/pricemanagement/customerGroups`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

/**
 * 
 * @param salesOrg 
 * @returns 
 */
export async function getCustomers(salesOrg: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
    },
    url: `${BASE_URL}/api/pricemanagement/customers`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function saveCustomerGroup(salesOrg: string, customerGroupPayload: any): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/pricemanagement/customergroup/save`,
    data: customerGroupPayload,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}

export async function deleteCustomerGroup(salesOrg: string, customerGroupPayload: any): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/pricemanagement/customergroup/delete`,
    data: customerGroupPayload,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}


/*********************************************Remote Price Price Group Section*********************************************************** */
/**
 * 
 * @param salesOrg 
 * @returns 
 */
export async function getPriceChangePriceGroups(salesOrg: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
    },
    url: `${BASE_URL}/api/pricemanagement/priceGroups`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}


/**
 * 
 * @param salesOrg 
 * @returns 
 */
export async function downloadPriceGroupCSV(salesOrg: string): Promise<any> {
  let params: { [key: string]: string } = {
    clientId: "100",
    salesOrg: salesOrg
  }
  const config: AxiosRequestConfig = {
    method: "GET",
    params: params,
    url: `${BASE_URL}/api/pricemanagement/csv/pricegroup`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => console.error(err));
}

/**
 * 
 * @param salesOrg 
 * @param priceGroupData 
 * @returns 
 */
export async function uploadPriceGroupCSV(salesOrg: string, priceGroupData: File): Promise<any> {
  let params: { [key: string]: string } = {
    clientId: "100",
    salesOrg: salesOrg
  }
  let data = new FormData();
  data.append('pricegroup', priceGroupData);

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/pricemanagement/csv/pricegroup/stage`,
    data: data,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}

/**
 * 
 * @param salesOrg 
 * @param priceGroupPayload 
 * @returns 
 */
export async function savePriceGroup(salesOrg: string, priceGroupPayload: any): Promise<any> {
  let params: { [key: string]: string } = {
    clientId: "100",
    salesOrg: salesOrg
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/pricemanagement/pricegroup/save`,
    data: priceGroupPayload,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}

/**
 * 
 * @param salesOrg 
 * @param deletePriceGroupPayload 
 * @returns 
 */
export async function deletePriceGroup(salesOrg: string, deletePriceGroupPayload: any): Promise<any> {
  let params: { [key: string]: string } = {
    clientId: "100",
    salesOrg: salesOrg
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/pricemanagement/pricegroup/delete`,
    data: deletePriceGroupPayload,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);
}

export async function downloadPriceRequestCSV(salesOrg: string): Promise<any> {
     let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  const config: AxiosRequestConfig = {
    method: "GET",
    params: params,
    url: `${BASE_URL}/api/pricemanagement/csv/pricerequest/`,
    };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
     .catch((err) => console.error(err));
}



export async function getPriceChangePriceGroupsList(salesOrg: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
    },
    url: `${BASE_URL}/api/pricemanagement/priceGroupsList`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function getMaterialsForPriceGroups(salesOrg: string,group_name:string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      group_name,
    },
    url: `${BASE_URL}/api/pricemanagement/materialsForPriceGroup`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function getCustomerGroupList(salesOrg: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
    },
    url: `${BASE_URL}/api/pricemanagement/customerGroupList`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function getReviewSimulationData(salesOrg: string,customers:any,priceGroups:any) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
      customer_num: customers,
      price_groups:priceGroups
    },
    url: `${BASE_URL}/api/pricemanagement/getPriceSimulationData`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}


export async function SubmitReviewDataForApproval(salesOrg: string,simulationData:any) {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/pricemanagement/submitSimulationData`,
    data: simulationData,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}


export async function priceChangeRequestData(salesOrg: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
    },
    url: `${BASE_URL}/api/pricemanagement/priceChangeRequestData`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function handleApproval(reqIdentifier: string,status:string,salesOrg:string, rejectionMsg: string = "") {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      reqIdentifier,
      status,
      rejectionMsg
    },
    url: `${BASE_URL}/api/pricemanagement/handleApproval`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}
/*********************************************Remote Price Email DL Section*********************************************************** */

/*********************************************Remote Price Email DL Section*********************************************************** */
export async function getRemotePriceEmailDL(salesOrg: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
    },
    url: `${BASE_URL}/api/pricemanagement/emaildl`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function saveRemotePriceEmailDL(salesOrg: string, emailDLPayload: string): Promise<any> {
  let params: { [key: string]: string } = {
    clientId: "100",
    salesOrg: salesOrg
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/pricemanagement/emaildl/save`,
    data: emailDLPayload,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);

}


export async function deleteRemotePriceEmailDL(salesOrg: string, emailDLPayload: string): Promise<any> {
  let params: { [key: string]: string } = {
    clientId: "100",
    salesOrg: salesOrg
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    params: params,
    url: `${BASE_URL}/api/pricemanagement/emaildl/delete`,
    data: emailDLPayload,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => err.response);

}
